import React from 'react'
import { Row, Col, Select, Button } from 'antd';
import styles from './Header.less';

export default function Header(props) {
  const { value, type, onChange, onTypeChange, goBack, title } = props;

  const start = 0;
  const end = 12;
  const monthOptions = [];

  const current = value.clone();
  const localeData = value.localeData();
  const months = [];
  for (let i = 0; i < 12; i++) {
    current.month(i);
    months.push(localeData.monthsShort(current));
  }

  for (let index = start; index < end; index++) {
    monthOptions.push(
      <Select.Option className="month-item" value={`${index}`} key={`${index}`}>
        {months[index]}
      </Select.Option>,
    );
  }
  const month = value.month();

  const year = value.year();
  const options = [];
  for (let i = year - 10; i < year + 10; i += 1) {
    options.push(
      <Select.Option key={i} value={`${i}`} className="year-item">
        {i}
      </Select.Option>,
    );
  }
  return (
    <div className={styles.calenderHeaderRender}>
      <Row>
        <Col style={{ lineHeight: '33px', fontSize: 20 }} span={4}>{title}</Col>
        <Col span={20} style={{ textAlign: 'center' }}>
          <Select 
            onChange={newYear => {
            const now = value.clone().year(newYear);
            onChange(now);}}
            value={String(year)} dropdownMatchSelectWidth={false} style={{ width: 100 }}
          >
            {options}
          </Select>
          <Select 
            value={String(month)}
            onChange={selectedMonth => {
              const newValue = value.clone();
              newValue.month(parseInt(selectedMonth, 10));
              onChange(newValue);
            }}
            style={{ width: 100,marginLeft:20 }} 
          >
            {monthOptions}
          </Select>
          <Button style={{marginLeft:20}} type='primary' onClick={goBack}>返回今天</Button>
        </Col>
      </Row>
    </div>
  )
}
